import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useApolloClient } from '@apollo/client'
import { Message, Button } from 'semantic-ui-react'
import ProfilePicture from '../ProfilePicture'
import General from '../../Forms/General'
import Professional from '../../Forms/Professional'
import Expertise from '../../Forms/Expertise'
import EEO from '../../Forms/EEO'
import DataContext from '../../../contexts/DataContext'
import ExpertProfile from '../../../lib/ExpertProfile'

const Edit = ({ profile, setProfile, onSave }) => {
  const history = useHistory()
  const apolloClient = useApolloClient()
  const { advisor } = useContext(DataContext)

  const [errorMsg, setErrorMsg] = useState('')
  const [loading, setLoading] = useState(false)

  const submitChange = async (e) => {
    e.preventDefault()

    const errorMessage = ExpertProfile.hasInvalidFields(profile)
    if (errorMessage) {
      window.scrollTo(0, 0)
      return setErrorMsg(errorMessage)
    }

    setLoading(true)
    try {
      const updatedProfile = await ExpertProfile.update(apolloClient, profile)
      // Reset window view
      window.scrollTo(0, 0)
      setProfile(updatedProfile)
      onSave()
      if (!advisor.expert.stripeAccount) history.push('/payment')
    } catch (err) {
      setErrorMsg(err.message)
    } finally {
      setLoading(false)
    }
  }

  const cancel = () => {
    setProfile(advisor.expert) // Reset profile
    onSave()
  }

  return (
    <div>
      {errorMsg && <Message negative>{errorMsg}</Message>}
      <div className="form-section">
        <ProfilePicture />
        <div style={{ textAlign: 'right' }}>
          <small className="require-indication">
            <span className="require-star">*</span> indicates required fields
          </small>
        </div>
        <General profile={profile} setProfile={setProfile} />
        <Professional
          profile={profile}
          setProfile={setProfile}
          showProfessionalRegistration={true}
        />
        <Expertise profile={profile} setProfile={setProfile} />
        <EEO profile={profile} setProfile={setProfile} />
      </div>
      <Button
        primary
        className="profile-btn-section"
        floated="right"
        loading={loading}
        disabled={loading}
        onClick={submitChange}
      >
        {`Save${advisor.expert.stripeAccount ? '' : ' and Continue'}`}
      </Button>
      <Button
        className="profile-btn-section"
        floated="right"
        loading={loading}
        disabled={loading}
        onClick={cancel}
      >
        Cancel
      </Button>
    </div>
  )
}

export default Edit
